export default "__VITE_ASSET__DYPMWRqG__"